// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Cross } from '../../assets/svg/common';
import theme from '../../styled-components/dark';
import { MyMatchCircleWrapper, MyMatchSelectionCircle } from '../../styled-components/shared';

const OutcomeRemovalButton = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 1em;
  height: 1em;
  cursor: pointer;

  border-radius: 50%;
  background-color: #292e3d;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 4px;
`;

const StyledCross = styled(Cross)`
  position: relative;
  width: 1em;
  height: 1em;
  fill: ${theme.BasketCard.closeButtonColor};
  stroke: ${theme.BasketCard.closeButtonColor};
`;

const Wrapper = styled(MyMatchCircleWrapper)`
  position: relative;
  padding: 0 1.5em 0.625em 1.5em;

  ${({ $hasError }) =>
    $hasError
      ? css`
          padding-left: 2em;
        `
      : css`
          padding-left: 1.5em;
        `}

  color: ${theme.BasketCard.subLabelColor};
  text-align: left;

  ::before,
  ::after {
    left: 0.7em;
  }

  & > span,
  & > ${OutcomeRemovalButton} {
    transform: translateY(0.25em);
  }
`;

const StyledSelectionCircle = styled(MyMatchSelectionCircle)`
  left: 0.7em;
`;

const BetTitle = styled.span`
  display: ${({ $shouldBreakLine }) => ($shouldBreakLine ? 'block' : 'inline-block')};
  color: #c1c9cf;
  font-size: 95%;
  padding-right: 0.3em;
  pointer-events: none;
`;

const OutcomesLabel = styled.span`
  display: ${({ $shouldBreakLine }) => ($shouldBreakLine ? 'block' : 'inline-block')};
  line-height: 1.2em;
  color: #fff;
  font-weight: bold;
  text-align: left;
  margin: 0;
  font-size: 105%;
  pointer-events: none;
`;

const INFOS_ICON_PADDING = 0.8; // em

const Icon = styled.div`
  font-size: 70%;

  position: absolute;
  left: 1em;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);

  padding: ${INFOS_ICON_PADDING / 3}em ${INFOS_ICON_PADDING}em;
  color: ${theme.InfosLabel.infosRed.backgroundColor};
  transform-style: preserve-3d;
  font-weight: bold;

  z-index: 2;

  &:after {
    content: '';
    position: absolute;
    width: ${INFOS_ICON_PADDING * 2}em;
    height: ${INFOS_ICON_PADDING * 2}em;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, -1px);
    z-index: -1;
    border-radius: 50%;
    background-color: ${theme.InfosLabel.infosRed.symbolBackgroundColor};
  }
`;

type BasketCardMyMatchContentItemProps = {
  className?: string;
  nbItems: number;
  betTitle: string;
  LabelComponent: unknown;
  shouldBreakLine: boolean;
  hasError: boolean;
  hasPreviousError: boolean;
  onOutcomeRemoval: () => void;
  isRemovalAllowed: boolean;
};

const BasketCardMyMatchContentItem = ({
  className = '',
  nbItems,
  betTitle,
  LabelComponent,
  shouldBreakLine,
  hasError,
  hasPreviousError,
  onOutcomeRemoval,
  isRemovalAllowed,
}: BasketCardMyMatchContentItemProps) => {
  return (
    <Wrapper className={className} $hasError={hasError} $hasPreviousError={hasPreviousError}>
      {isRemovalAllowed ? (
        <OutcomeRemovalButton onClick={onOutcomeRemoval}>
          <StyledCross />
        </OutcomeRemovalButton>
      ) : null}
      {hasError ? <Icon>!</Icon> : null}
      {nbItems > 1 ? <StyledSelectionCircle /> : null}
      <BetTitle $shouldBreakLine={shouldBreakLine}>{betTitle}</BetTitle>
      <OutcomesLabel $shouldBreakLine={shouldBreakLine}>{LabelComponent}</OutcomesLabel>
    </Wrapper>
  );
};

export default BasketCardMyMatchContentItem;
